import { cleanClassName } from '@wello-client/common/utils';
import Link from 'next/link';

import { useGlobalStore } from '@/stores/GlobalStore';

import styles from './LinkableBox.module.scss';

interface LinkableBoxProps {
  href?: string;
  children: React.ReactNode;
  className?: string;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
  as?: keyof JSX.IntrinsicElements | React.ElementType;
}

export const LinkableBox = ({
  href,
  className,
  as: Component = 'div',
  ...restProps
}: LinkableBoxProps) => {
  if (href && href !== '#')
    return (
      <Link
        {...restProps}
        className={cleanClassName(`${styles['linkable-box']} ${className}`)}
        href={href}
        onClick={() => useGlobalStore.getState().setIsGlobalLoading(true)}
      />
    );

  return <Component {...restProps} className={className} />;
};
